import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faShieldAlt, faCalendar, faSave, faArrowLeft, faHome } from '@fortawesome/free-solid-svg-icons';
import './ProfilePage.css';

export const ProfilePage: React.FC = () => {
  const { user, changePassword } = useAuth();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handlePasswordChange = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setMessage('As senhas não coincidem');
      setIsLoading(false);
      return;
    }

    const result = await changePassword(passwordData);
    if (result.success) {
      setMessage('Senha alterada com sucesso!');
      setPasswordData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    } else {
      setMessage(result.error || 'Erro ao alterar senha');
    }
    setIsLoading(false);
  };

  const getRoleDisplay = (role: string) => {
    const roles = {
      master: 'Master',
      admin: 'Administrador',
      user: 'Usuário'
    };
    return roles[role as keyof typeof roles] || role;
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };


  if (!user) return null;

  return (
    <div className="app-container">
      <Header />
      <div className="profile-container">
        <div className="profile-header">
          <div className="profile-header-top">
            <div className="profile-header-actions">
              <button 
                onClick={handleGoBack}
                className="profile-btn-back"
              >
                <FontAwesomeIcon icon={faArrowLeft} />
                Voltar
              </button>
              <button 
                onClick={handleGoHome}
                className="profile-btn-home"
              >
                <FontAwesomeIcon icon={faHome} />
                Início
              </button>
            </div>
          </div>
          <div className="profile-header-content">
            <h1 className="profile-title">Meu Perfil</h1>
            <p className="profile-subtitle">Gerencie suas informações pessoais e configurações de conta</p>
          </div>
        </div>

      <div className="profile-content">
        <div className="profile-card">
          <div className="profile-avatar">
            <FontAwesomeIcon icon={faUser} size="3x" />
          </div>
          
          <div className="profile-info">
            <h2 className="profile-name">{user.name}</h2>
            <div className="profile-email">
              <FontAwesomeIcon icon={faEnvelope} />
              <span>{user.email}</span>
            </div>
            <div 
              className={`profile-role profile-role-${user.role}`}
            >
              <FontAwesomeIcon icon={faShieldAlt} />
              <span>{getRoleDisplay(user.role)}</span>
            </div>
            <div className="profile-date">
              <FontAwesomeIcon icon={faCalendar} />
              <span>Membro desde {new Date(user.createdAt).toLocaleDateString('pt-BR')}</span>
            </div>
          </div>
        </div>

        <div className="profile-actions">
          <button
            onClick={() => setIsEditing(!isEditing)}
            className="profile-edit-button"
          >
            {isEditing ? 'Cancelar' : 'Alterar Senha'}
          </button>
        </div>

        {isEditing && (
          <div className="profile-password-form">
            <h3 className="profile-form-title">Alterar Senha</h3>
            <form onSubmit={handlePasswordChange}>
              <div className="profile-field">
                <label htmlFor="currentPassword" className="profile-label">
                  Senha Atual
                </label>
                <input
                  type="password"
                  id="currentPassword"
                  value={passwordData.currentPassword}
                  onChange={(e) => setPasswordData(prev => ({
                    ...prev,
                    currentPassword: e.target.value
                  }))}
                  className="profile-input"
                  required
                />
              </div>

              <div className="profile-field">
                <label htmlFor="newPassword" className="profile-label">
                  Nova Senha
                </label>
                <input
                  type="password"
                  id="newPassword"
                  value={passwordData.newPassword}
                  onChange={(e) => setPasswordData(prev => ({
                    ...prev,
                    newPassword: e.target.value
                  }))}
                  className="profile-input"
                  required
                />
              </div>

              <div className="profile-field">
                <label htmlFor="confirmPassword" className="profile-label">
                  Confirmar Nova Senha
                </label>
                <input
                  type="password"
                  id="confirmPassword"
                  value={passwordData.confirmPassword}
                  onChange={(e) => setPasswordData(prev => ({
                    ...prev,
                    confirmPassword: e.target.value
                  }))}
                  className="profile-input"
                  required
                />
              </div>

              {message && (
                <div className={`profile-message ${message.includes('sucesso') ? 'success' : 'error'}`}>
                  {message}
                </div>
              )}

              <button
                type="submit"
                className="profile-save-button"
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faSave} />
                {isLoading ? 'Salvando...' : 'Salvar Senha'}
              </button>
            </form>
          </div>
        )}
      </div>
      </div>
      <Footer />
    </div>
  );
};
